import { createContext } from "react";

export const AssignmentContext = createContext({});